// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2fNbW","footer":"ModalFilter_footer__3i_gF"};